// extracted by mini-css-extract-plugin
module.exports = {"title":"browse-BrowseInstruments__title--1wxgE"};